/**
 * PinToggle — pin a catalogue entry to the top (brief-26).
 *
 * Quiet at rest, like the rest of the card: the outline pin only appears on card
 * hover/focus (the same two-stage rule the admin row follows). A PINNED entry is
 * the exception — it stays visible always, because it is explaining why that
 * entry is at the top of the list.
 */

import { t } from '../i18n';

interface PinToggleProps {
  pinned: boolean;
  title: string;
  onToggle: () => void;
}

export default function PinToggle({ pinned, title, onToggle }: PinToggleProps) {
  const label = (pinned ? t('tile.pin.unpin') : t('tile.pin.pin')).replace('{{service}}', title);

  return (
    <button
      type="button"
      className={`dp-pin${pinned ? ' dp-pin--on' : ''}`}
      aria-pressed={pinned}
      aria-label={label}
      title={label}
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
    >
      <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
        <path
          d="M6 1.5h4a.5.5 0 0 1 .35.85L9.5 3.2v3.3l2.2 1.9a.8.8 0 0 1 .3.6v.5a.5.5 0 0 1-.5.5H8.6v4.2a.6.6 0 0 1-1.2 0V10H4.5a.5.5 0 0 1-.5-.5V9a.8.8 0 0 1 .3-.6l2.2-1.9V3.2l-.85-.85A.5.5 0 0 1 6 1.5Z"
          fill={pinned ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
